<template>
  <section class="layout-main">
    <section class="content">
      <section class="mount scroll-y">
        <router-view />
      </section>
    </section>
  </section>
</template>
<script lang="ts" setup>
import { ref,computed } from 'vue'
import { useRoute } from 'vue-router'
import BottomTabBar from '@/components/BottomTabBar/index.vue'

const route = useRoute()
const activeTab = ref('home')

</script>

<style lang="scss" scoped>
.layout-main {
  width: 100%;
  height: 100%;
  &.showNavList{
    ::v-deep(.slot-box){
      padding-bottom: 80px;
      height: auto;
    }
 }
  .content {
    width: 100%;
    height: 100%;
    .mount {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
